export default "__VITE_ASSET__Dkn0$Xo1__"